import { axiosClient } from '../../../library/Service/axiosClient';
import pageConfig from './PageConfig.json';

class ConversationReportService {
    static pageLoader(params: any): Promise<any> {
        const state: any = {};
        const searchCriteria = ConversationReportService.getDefaultSearchCriteria();

        // Only fetch config (local JSON — instant). SearchCriteria fetches the list
        // on mount, so calling search() here causes a double API call.
        return ConversationReportService.getPageConfig().then((formConfig) => {
            state.formConfig = formConfig;
            state.data = {
                alumniList: [],
                searchCriteria: { ...searchCriteria },
            };
            state.routeInfo = params;
            state.internal = { gridState: {} };
            return Promise.resolve(state);
        });
    }

    static search(searchCriteria: any, reportType: string): any {
        const payload = ConversationReportService.sanitizeSearchCriteria(searchCriteria);
        return axiosClient().post(`${process.env.REACT_APP_MESSAGE_SERVER}/conversations/all-conversation-list`, payload);
    }

    static getPageConfig() {
        return Promise.resolve(pageConfig);
    }

    static sanitizeSearchCriteria(searchCriteria: any) {
        const criteria = { ...searchCriteria };
        for (const [key, value] of Object.entries(searchCriteria)) {
            criteria[key] = Array.isArray(value) && typeof value[0] === 'object' ? value.map((obj) => Object.values(obj)[0]) : value;
        }
        return criteria;
    }

    static searchCount(searchCriteria: any, pageName: string) {
        const criteria = this.sanitizeSearchCriteria(searchCriteria);
        return axiosClient().post(`${process.env.REACT_APP_MESSAGE_SERVER}/conversations/all-conversation-list-count`, criteria);
    }

    static searchTwowayconversationCount(searchCriteria: any, pageName: string) {
        const criteria = this.sanitizeSearchCriteria(searchCriteria);
        return axiosClient().post(`${process.env.REACT_APP_MESSAGE_SERVER}/conversations/twoway-conversation-list-count`, criteria);
    }

    static getExportToExcelColumns = (pageName: string) => {
        const reportConfig: any = {
            'conversation-report': [
                'conversationId',
                'createdAt',
                'createdBy',
                'updatedAt',
                'updatedBy',
                'senderId',
                'senderFullName',
                'senderRegisteredEmailId',
                'senderInstituteName',
                // 'senderPassOutYear',
                'senderProgramName',
                'senderUserType',
                'message',
                'receiverUUID',
                'receiverFullName',
                'receiverEmailId',
                'receiverProgramName',
                'receiverInstituteName',
                'senderProfileAutologinlink',
                'receiverProfileAutologinlink'
            ],
        };

        return reportConfig[pageName];
    };
    
    static getDefaultSearchCriteria(): any {
        return {
            createdFromDate: [],
            createdToDate: '',
            updatedFromDate:[],
            updatedToDate:'',
            senderType:'',
            receiverType:'',
        };
    }
}

export default ConversationReportService;
